/**
 * Customer-level metering-provider custom field `access_grant`.
 * Caps/overrides invoice-driven dunning; never grants product features.
 */
export enum AccessGrantEnum {
  ALLOW = 'allow',
  DENY = 'deny',
  AUTO = 'auto',
}
